import type {
  Message,
  Part,
  PermissionRequest,
  Project,
  QuestionRequest,
  Session,
  SessionStatus,
  FileDiff,
} from "@mux/sdk/v2/client"
import { produce, reconcile, type SetStoreFunction } from "solid-js/store"
import type { GlobalStore, PtyActivity, SessionDiffSummary } from "./types"

export function createGlobalStoreOperations(setStore: SetStoreFunction<GlobalStore>) {
  const projects = {
    replace(items: Project[]) {
      setStore("project", reconcile(items, { key: "id" }))
    },
    mutate(mutator: (draft: Project[]) => void) {
      setStore("project", produce(mutator))
    },
  }

  const sessions = {
    replace(items: Session[]) {
      setStore("session", reconcile(items, { key: "id" }))
    },
    update(updater: (items: Session[]) => Session[]) {
      setStore("session", updater)
    },
    mutate(mutator: (draft: Session[]) => void) {
      setStore("session", produce(mutator))
    },
    total(directory: string, updater: (value: number | undefined) => number) {
      setStore("sessionTotal", directory, updater)
    },
    status(sessionID: string, status: SessionStatus | undefined) {
      setStore("session_status", sessionID, status === undefined ? undefined : reconcile(status))
    },
    messages(sessionID: string, messages: Message[] | undefined) {
      setStore("message", sessionID, messages)
    },
    parts(messageID: string, parts: Part[] | undefined) {
      setStore("part", messageID, parts)
    },
    permissions(sessionID: string, permissions: PermissionRequest[]) {
      setStore("permission", sessionID, permissions)
    },
    questions(sessionID: string, questions: QuestionRequest[]) {
      setStore("question", sessionID, questions)
    },
    diff(sessionID: string, diff: FileDiff[] | undefined) {
      setStore("session_diff", sessionID, diff)
    },
    diffSummary(sessionID: string, summary: SessionDiffSummary | undefined) {
      setStore("session_diff_summary", sessionID, summary)
    },
  }

  return {
    projects,
    sessions,
    ptyActivity(sessionID: string, activity: PtyActivity) {
      setStore("pty_activity", sessionID, activity)
    },
  }
}
